import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  TAppraisalGroupDto,
  TNewAppraisalFlowRequest,
  useAvApi,
} from '@app-velocity/av-api-v2';

export const useStartAppraisalMutation = (workspaceId?: string) => {
  const queryClient = useQueryClient();
  const { appraisals } = useAvApi();

  return useMutation({
    mutationKey: ['start-appraisal-mutation'],
    mutationFn: async (body: TNewAppraisalFlowRequest) => {
      if (!workspaceId) return;

      const res = await appraisals.postAppraisalsAiByProjectId(body, {
        projectId: workspaceId,
      });

      return res.data;
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(
        ['appraisal-remarks', workspaceId, data?.entityId, 'authorized'],
        {
          remarks: [],
          id: data?.entityId,
          nodeId: variables?.nodeId,
          nodeImage: variables?.pageImage,
          method: variables?.method,
          nodeName: variables?.nodeName,
          appraisalStatus: 'IN_PROGRESS'
        } as TAppraisalGroupDto
      );
    },
  });
};
